export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";